import React from "react";
import Solicitudes from "../../components/2.3 procesos/procesos";

const HomePage = () => {
  return (
    <>
      <Solicitudes />
    </>
  );
};

export default HomePage;
